class TmplTable {


    static make(_d){
        return `
<table class="custom-table">
    <tbody>
        ${_d.map( itemTd => {
            let tdList = itemTd.map( item => {
                if( item.merged === '1' ) return '';
                let sizeX = (item.size_x)? ` colspan="${parseInt(item.size_x)+1}"`: '';
                let sizeY = (item.size_y)? ` rowspan="${parseInt(item.size_y)+1}"`: '';
                let style = (item.style)? ` class="${item.style}"`: '';
                return `<td${style}${sizeX}${sizeY}>${item.text}</td>`;
            } ).join('\n ');

            return `<tr>${tdList}</tr>`;
        } ).join('\n ')}
    </tbody>
</table>`
    }

}


export default TmplTable;




// WEBPACK FOOTER //
// ./lineage/TmplTable.js